import { useCallback, useEffect, useState } from 'react';
import Cookies from 'js-cookie';

export const useCookie = () => {
  const getCookie = useCallback((key: string) => {
    return Cookies.get(key);
  }, []);

  const setCookie = useCallback((key: string, value: string, options: any) => {
    Cookies.set(key, value, options);
  }, []);

  const removeCookie = useCallback((key: string) => {
    Cookies.remove(key);
  }, []);

  return {
    getCookie,
    setCookie,
    removeCookie,
  }
}

export const useGetCookieByKey = (key: string) => {
  const { getCookie } = useCookie();
  const [cookieValue, setCookieValue] = useState<string | null>(null);

  useEffect(() => {
    setCookieValue(getCookie(key) || null);
  }, [getCookie, key]);

  return cookieValue;
}